import { use } from 'react';
import { TimesheetModalActionsContext, TimesheetModalStateContext } from '../components/TimesheetModalContext';

export const useTimesheetModalState = () => use(TimesheetModalStateContext);

export const useTimesheetModalActions = () => use(TimesheetModalActionsContext);
